import { urlEncode } from '@services/Url';

const serializeFormData = data => ({
  contentGuidString: data.contentGuidString,
  subHeaderString: data.subHeaderString,
  title: data.title,
  cite: data.cite,
  cTALabel: data.cTALabel,
  cTAUrl: data.cTAUrl,
  effectivePostedDateString: data.effectivePostedDateString,
  dateTypeString: data.dateTypeString,
  summary: data.summary,
  activeDateString: data.activeDateString,
});

const eBarSCOAnnouncementsCreate = async (data) => {
  const eBarCreate = await fetch('/EBarSCOAnnouncementsCTABlock/CreateEBarSCOAnnouncement', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: urlEncode({
      input: JSON.stringify(serializeFormData(data)),
    }),
  });
  const eBarCreateJson = eBarCreate.json();

  return eBarCreateJson;
};

const eBarSCOAnnouncementsUpdate = async (data) => {
  const eBarUpdate = await fetch('/EBarSCOAnnouncementsCTABlock/UpdateEBarSCOAnnouncement', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: urlEncode({
      input: JSON.stringify(serializeFormData(data)),
    }),
  });
  const eBarUpdateJson = eBarUpdate.json();

  return eBarUpdateJson;
};

const eBarSCOAnnouncementsDelete = async (data) => {
  const eBarDelete = await fetch('/EBarSCOAnnouncementsCTABlock/DeleteEBarSCOAnnouncement', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: urlEncode({
      stringToDelete: data,
    }),
  });
  const eBarDeleteJson = eBarDelete.json();

  return eBarDeleteJson;
};


export {
  eBarSCOAnnouncementsCreate,
  eBarSCOAnnouncementsUpdate,
  eBarSCOAnnouncementsDelete,
};
